import { MasterDataVehicleDetailPage } from "@/pages/master-data-vehicle-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/master-data/vehicles/$id/",
)({
  component: () => {
    const { id: vehicleIdStr } = useParams({
      from: "/_auth_requeired/master-data/vehicles/$id/",
    });
    return <MasterDataVehicleDetailPage vehicleIdStr={vehicleIdStr} />;
  },
});
